import type { EditorInput } from "@/components/Form/ComplexMarkdownField/types";
import type { RichTextValue } from "@/components/Form/RichTextField";
import {
  chipOptionsToSuggestionItems,
  type AdvancedChipOption,
} from "@/components/Form/TiptapEditor/chipOptionsConfig";

export type StoredTextValue =
  | string
  | RichTextValue
  | RichTextValue[]
  | null
  | undefined;

// A V1 text field holds a plain string or the rich text editor's
// { text, definition }; the text is what runs. An array is the March 2025
// bug RichTextField also unwraps.
export function storedTextValue(value: StoredTextValue): string {
  const unarrayed = Array.isArray(value) ? value[0] : value;
  if (typeof unarrayed === "string") return unarrayed;
  return unarrayed?.text ?? "";
}

// The id is the token body the engine substitutes, prefix included, so
// ((@name)) keeps meaning a reference mention.
export function chipOptionsToEditorInputs(
  groups: AdvancedChipOption[]
): EditorInput[] {
  return chipOptionsToSuggestionItems(groups).map((item) => ({
    id: `${item.prefix ?? ""}${item.id}`,
    name: item.label,
    dataType: item.dataType ?? "str",
    isList: item.isList ?? false,
    sourceName: item.sourceName ?? item.group,
    sourceImage: item.sourceImage,
    sourceColor: item.sourceColor,
    sourceKind: item.sourceKind,
  }));
}
